export default "__VITE_ASSET__ByZ7ktbY__"